export default __webpack_public_path__ + "b8dafbae67fc5771a7193e5bc03f8313.jpg";